export const reducerTypes = {
  GET_ALL_OFFERS: "reducer/GET_ALL_OFFERS",
  GET_MORE_OFFERS: "reducer/GET_MORE_OFFERS",
  SET_PAGE_INFO: "reducer/SET_PAGE_INFO",
  SET_PAGE_INDEX: "reducer/SET_PAGE_INDEX",
  SET_PAGE_SIZE: "reducer/SET_PAGE_SIZE",
  GET_OFFER: "reducer/GET_OFFER",
  IS_LOADING: "reducer/LOADING_TRUE",
};

export const sagaTypes = {
  GET_ALL_OFFERS: "saga/GET_ALL_OFFERS",
  GET_MORE_OFFERS: "saga/GET_MORE_OFFERS",
  GET_OFFER: "saga/GET_OFFER",
};
